import CardTermsUS from "./CardTermsUS";

/**
 * US card application and legacy `/auth/card/disclosures-agreement`
 * show the same SET CREDIT LIMIT disclosures and cardholder agreement.
 */
const CardDisclosuresAgreement = () => <CardTermsUS />;

export default CardDisclosuresAgreement;
